import * as React from 'react';
import CR29DataCore from '../CourtReporting/CR29DataCore';
import { UserRoleEnum } from '../../redux/UserSlice';



const CR29DataB = (props: any) => {
    return (
        <React.Fragment>
            <CR29DataCore userRole={UserRoleEnum.EntityUser} dataSection={"PartB"} />
        </React.Fragment>
    );
}

export default CR29DataB;